import { Component, OnInit } from '@angular/core'

@Component({
    selector: './achelous-users',
    templateUrl: './achelous-users.component.html',
    styleUrls: ['../../../../../help.component.css']
})

export class AchelousUsersComponent implements OnInit {

    ngOnInit() {

    }
}